import * as types from '../mutations'
import axios from 'axios'

const state = {
    list: {},
    filter: '',
    page: 1,
    loading: false,
}

const mutations = {

    [types.ATTACHMENTS_SET_LIST] (state, list)
    {
        state.list = list
    },

    [types.ATTACHMENTS_SET_FILTER] (state, filter)
    {
        state.filter = filter
        state.page = 1
    },

    [types.ATTACHMENTS_SET_PAGE] (state, page)
    {
        state.page = page
    },

    [types.ATTACHMENTS_SET_LOADING] (state, loading)
    {
        state.loading = loading
    }

}

const actions = {

    init({dispatch})
    {
        try {
          dispatch('attachmentsFetch')
        } catch(e) {}
    },

    attachmentsFetch({commit, state, rootState})
    {
        return new Promise(async(resolve, reject) => {
            commit(types.ATTACHMENTS_SET_LOADING, true)
            try {
                const list = await axios.get(process.env.API_URL + '/v1/admin/attachments', { params: { name: state.filter, page: state.page, per_page: 3 }})
                if (list)
                {
                    commit(types.ATTACHMENTS_SET_LIST, list.data)
                    commit(types.ATTACHMENTS_SET_LOADING, false)
                    resolve(list.data.data)
                } else {
                    commit(types.ATTACHMENTS_SET_LOADING, false)
                    reject()
                }
            } catch (e) {
                commit(types.ATTACHMENTS_SET_LOADING, false)
                reject()
            }
        })
    },

    attachmentsFilter({commit, dispatch}, filter)
    {
        commit(types.ATTACHMENTS_SET_FILTER, filter)
        dispatch('attachmentsFetch')
    },

    attachmentsPage({commit, dispatch}, page)
    {
        commit(types.ATTACHMENTS_SET_PAGE, page)
        dispatch('attachmentsFetch')
    },

}

const getters = {
    attachmentsList: state => JSON.parse(JSON.stringify(state.list)),
    attachmentsFilter: state => JSON.parse(JSON.stringify(state.filter)),
    attachmentsPage: state => JSON.parse(JSON.stringify(state.page)),
    attachmentsLoading: state => JSON.parse(JSON.stringify(state.loading)),
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/attachments.js